module.exports = __webpack_public_path__ + "img/traininglukas.735e1335.jpg";